import { isString } from "underscore";
export default class RecipientUtils {
    static mapStepMetaRecipientGroups(stepMetaGroups) {
        const groups = [];
        stepMetaGroups.map((groupObj) => {
            if (groupObj.hasOwnProperty("groupName")) {
                groups.push(groupObj);
            }
            else {
                groups.push({
                    groupName: groupObj.GroupName, groupType: groupObj.GroupType, requiredFields: groupObj.requiredFields
                });
            }
        });
        return groups;
    }
    static removeRecipientProperties(recipientToDeleteFrom) {
        if (recipientToDeleteFrom) {
            if (recipientToDeleteFrom.hasOwnProperty("id")) {
                if (isString(recipientToDeleteFrom.id) && recipientToDeleteFrom.id.indexOf("-") >= 0) {
                    recipientToDeleteFrom.id = 0;
                }
                if (recipientToDeleteFrom.id === null) {
                    delete recipientToDeleteFrom.id;
                }
            }
            if (recipientToDeleteFrom.hasOwnProperty("jobId") && recipientToDeleteFrom.jobId === null) {
                delete recipientToDeleteFrom.jobId;
            }
            if (recipientToDeleteFrom.hasOwnProperty("groupsStringArray")) {
                delete recipientToDeleteFrom.groupsStringArray;
            }
            if (recipientToDeleteFrom.hasOwnProperty("emailField")) {
                delete recipientToDeleteFrom.emailField;
            }
            if (recipientToDeleteFrom.hasOwnProperty("sacapRegistrationNumber")) {
                delete recipientToDeleteFrom.sacapRegistrationNumber;
            }
            if (recipientToDeleteFrom.hasOwnProperty("overrideGroup")) {
                delete recipientToDeleteFrom.overrideGroup;
            }
            if (recipientToDeleteFrom.hasOwnProperty("selected")) {
                delete recipientToDeleteFrom.selected;
            }
            if (recipientToDeleteFrom.hasOwnProperty("consolidatedGroup")) {
                delete recipientToDeleteFrom.consolidatedGroup;
            }
            if (recipientToDeleteFrom.hasOwnProperty("lastEditedDate")) {
                delete recipientToDeleteFrom.lastEditedDate;
            }
            if (recipientToDeleteFrom.hasOwnProperty("lastEditedUserId")) {
                delete recipientToDeleteFrom.lastEditedUserId;
            }
            if (recipientToDeleteFrom.hasOwnProperty("createdDate")) {
                delete recipientToDeleteFrom.createdDate;
            }
            if (recipientToDeleteFrom.hasOwnProperty("createdUserId")) {
                delete recipientToDeleteFrom.createdUserId;
            }
            if (recipientToDeleteFrom.hasOwnProperty("fullName")) {
                delete recipientToDeleteFrom.fullName;
            }
            if (recipientToDeleteFrom.hasOwnProperty("groupsStringArray")) {
                delete recipientToDeleteFrom.groupsStringArray;
            }
            if (recipientToDeleteFrom.hasOwnProperty("selected")) {
                delete recipientToDeleteFrom.selected;
            }
            recipientToDeleteFrom.groups?.forEach(group => {
                if (group.hasOwnProperty("requiredFields")) {
                    delete group.requiredFields;
                }
            });
        }
        return recipientToDeleteFrom;
    }
    static makeDeepCopies(recipient, overrideGroup, removeId) {
        const recipientDeepCopy = Object.assign({}, recipient);
        if (recipientDeepCopy.hasOwnProperty("id") && removeId) {
            delete recipientDeepCopy.id;
            recipientDeepCopy.id = 0;
        }
        if (overrideGroup) {
            recipientDeepCopy.overrideGroup = overrideGroup;
        }
        else {
            recipientDeepCopy.groups.forEach(group => {
                if (group.hasOwnProperty("id") && removeId) {
                    delete group.id;
                }
            });
        }
        return recipientDeepCopy;
    }
}
